<template>
<div>
    <v-card flat>
        <v-card-title v-if="survey.header && survey.header[$language()]">
            <template v-if="survey.mode!='live'">
            SURVEY STATE: {{survey.state}} | Questions Initialized: {{initQuestion_done}} | VERSION ID: {{survey.version_id}}
            </template>
            <div v-html="survey.header[$language()]"/>
        </v-card-title>


        <!-- DEV TOOLS -->
        <div :class="$style.devTools" v-if="$store.getters.mode=='edit'">
        <!-- <div :class="$style.devTools" v-if="false"> -->
            <transition name='slide-fade'>
                <div v-if="showDevTools" style="position: relative; background-color: whitesmoke;">
                    <div style="display: flex; flex-direction: row; width: 90%; margin: 15px auto; align-items: center; justify-content: center;">
                        <v-btn 
                            @click="showDevTools=false" 
                            fab 
                            x-small 
                            dark
                            depressed
                            style="position: absolute; top: -5%; right: 0px;" 
                            color="black">
                                <v-icon>
                                    fas fa-times
                                </v-icon>
                        </v-btn>
                        <div style="width: 25%;">
                            <v-select 
                                class="mx-5"
                                :items="['dev_run_hidden_logics','dev','test','qa','staging','live']" 
                                v-model="survey.mode" 
                                label="MODE: "
                                outlined 
                                flat
                                height=30
                                hide-details
                                dense /> 
                        </div>
                        <v-switch 
                            style="margin-top: 0px"
                            class="mx-5"
                            hide-details
                            v-model='showAll' 
                            label="Show All Questions"/>

                        <v-switch 
                            style="margin-top: 0px"
                            class="mx-5"
                            hide-details
                            v-model='enable_pagination' 
                            label="Enable Pagination"/>
                    </div>

                    <div style="margin-top: 10px;">
                        <v-btn small v-if="advanced.afterSubmit" @click="afterSubmit" color="pink">After Submit</v-btn> 

                        <v-btn 
                            small 
                            @click="getAnswers()" 
                            dark
                            color="#fbb863">
                                Get Answers
                        </v-btn>

                        <v-btn 
                            small 
                            @click="randomAnswers()" 
                            dark
                            color="#fbb863">
                                Random Answers
                        </v-btn>  

                        <template v-if="$store.getters.user.type == 'admin'">
                            <v-btn 
                                small 
                                @click="loadSurvey()" 
                                dark
                                color="#3aacc4">
                                    Load Published Survey
                            </v-btn>  

                            <v-btn 
                                small 
                                dark
                                @click="editSavedSurvey()" color="#3aacc4">
                                    Edit Saved Survey(s)
                            </v-btn>

                            <v-btn 
                                small 
                                dark
                                @click="editCachedSurvey()" 
                                color="#fd9595">
                                Edit Cache
                            </v-btn>

                            <v-btn 
                                small 
                                dark
                                @click="previewCachedSurvey()" 
                                color="#fd9595">
                                    Preview Cache
                            </v-btn>

                            <v-btn 
                                small 
                                dark
                                @click="makeSurveyReady()" 
                                color="#fd9595">
                                    Make Ready
                            </v-btn>
                        </template>
                    </div>
                    
                </div>
                <div v-else :class="$style.devToolsWrenchBtnWrapper">
                    <v-btn fab @click="showDevTools=true" color="primary">
                        <v-icon>
                            fa fa-wrench
                        </v-icon>
                    </v-btn>
                </div>
            </transition>
        </div>

        <div id="Box"> 
            <!-- SURVEY -->
            <div :class="$style.survey" v-if="survey.state=='validate-rules' || survey.state=='ready' || survey.state=='validate_survey' || survey.state=='submit_survey' || survey.state=='submit_complete'">
                <center>
                    <v-btn v-if="unsubmitted.cache.available()===true && logs.length==0 " small color="primary" @click="unsubmitted.cache.load()"><str :index="'survey > button > load_cache'"/></v-btn>
                </center>
                <!-- Completion Assistant -->
                <div v-if="survey.state=='validate_survey' && incomplete_questions.length>0" :class="$style.completionAssistant">
                    <v-dialog width="600">
                        <v-card class="pa-5" :class='$style.incompleteDialog'>
                            <v-card-title><str :index="'survey > message > incomplete_questions'"/></v-card-title>
                            <v-card-actions>
                                <v-spacer/>
                                    <v-btn color="primary" @click="display_incomplete_dialog=false"><str :index="'button > close'"/></v-btn>
                                <v-spacer/>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                    <p style="margin-bottom: 5px; margin-top: 5px; color: black; font-size: 18px; font-weight:400;">
                        <str index='survey > jump > title' />
                    </p>
                    <template v-for="(question,index) in incomplete_questions">
                        <v-btn small color="error" @click="question.focus();" :key="'incomplete_'+question.config.id" style="display: inline-block;margin: 3px;">
                            {{index+1}}
                        </v-btn>
                    </template>
                </div>

                <!-- TESTING TOOLS -->
                <v-select v-if="survey.state=='submit_complete'" v-model='select_answers' :items="submissions_list" label="Overlay Answers"/>
                <div v-if="(show_dev_info) && overlay_submission">
                    <template v-if="show_raw_answers">
                        <v-btn color="primary" @click="show_raw_answers=false">HIDE</v-btn>
                        <fieldset>
                            <legend><a href="http://jsonviewer.stack.hu/" target="_blank">Answers</a></legend>
                            {{overlay_submission.answers}}
                        </fieldset>

                        <fieldset>
                            <legend><a href="http://jsonviewer.stack.hu/" target="_blank">Others</a></legend>
                            {{overlay_submission.others}}
                        </fieldset>
                    </template>
                    <v-btn v-else color="primary" @click="show_raw_answers=true">RAW DATA</v-btn>
                    <v-btn color="primary" @click="applyAnswers">Apply Answers</v-btn>
                </div>

                <div v-if="show_dev_info" style="z-index: 1000; position:fixed; top:0px; left: 20%; padding: 8px; min-height: 50px; text-align: center;">
                    <transition name="slide-fade">
                        <div v-if="show_question_jumper">
                            <v-btn color="primary" @click="show_question_jumper=false">HIDE</v-btn>
                            <br>
                            <template v-for="(question, question_index) in survey.questions" >
                                <v-btn :color="question.display ? 'primary' : 'disabled'" @click="question.focus();" :key="'dev_'+question.config.id" style="display: inline-block;margin: 3px;">
                                    [P #{{question_index+1}}] QID:{{question.config.id}}
                                </v-btn>
                            </template>
                        </div>
                    </transition>

                    <transition name="slide-fade">
                        <div v-if="!show_question_jumper">
                            <v-btn color="primary" @click="show_question_jumper=true">MAP</v-btn>
                        </div>
                    </transition>                    
                </div>

                <v-pagination
                    v-if="enable_pagination"
                    v-model="page"
                    :length="pages"/>

                <!-- Questions -->
                <template v-for="(question, question_index) in survey.questions">

                    <div 
                        :key="question.config.id" 
                        :class="[{[$style.shownQuestion]:question.display || showAll===true}, 
                                {[$style.shownQuestionAltBackground]:checkShownQuestionIdEvenIndex(question, question_index, survey.questions) && showAll === false}, 
                                {[$style.shownQuestionAltBackgroundShowAll]:showAll === true}]" 
                        v-show="question_segment(question_index)">

                        <!-- TESTING TOOLS -->
                        <div v-if="survey.mode!='live'" style="text-decoration: underline; font-style: italic;" :style="{'color':(question.valid && question.valid.default && question.valid.advanced) ? 'green' : 'grey'}"><b>[#{{question_index+1}}]</b> QID: {{question.config.id}} {{question.display===true ? '' : 'hidden'}} - [{{question.config.type}}]</div>
                        <LogicDebugger v-if="show_dev_info" :question="question" :questionMap="questionMap" :surveyRules="survey.rules" :key="'logic_debug_sid_'+load.survey_id+'_qid_'+question.config.id"/>
                        <fieldset v-if="(show_dev_info) && overlay_submission!=null && overlay_submission.answers[question.config.id]">
                            <legend>Previous Answers: {{question.config.id}}</legend>
                            <ul>
                                <template v-for="(group, key, index) in overlay_submission.answers[question.config.id]">
                                    <li :key="'answer_'+question.config.id+'_'+key+'_'+index">
                                        {{group}}
                                        <br>
                                        <sub>Other: {{overlay_submission.others[question.config.id][key]}}</sub>
                                    </li>
                                </template>
                            </ul>
                        </fieldset>

                        <!-- Question Component -->
                        <!-- <transition name="slide-fade"> -->
                            <!-- <div style="width: 400px; height: 400px; border: 1px solid grey; margin: 15px;">{{question_index}}</div> -->
                            <component 
                                :class="{[$style.incomplete]:question.valid && !(question.valid.default && question.valid.advanced) && survey.state=='validate_survey'}"
                                v-show="(question.display || showAll===true)"
                                :id="'sid_'+load.survey_id+'_qid_'+question.config.id"
                                :is="question.config.type" 
                                :question="question"
                                :questionMap="questionMap"
                                :surveyRules="survey.rules"
                                :survey="survey"                         
                                @initQuestion="initQuestion"
                                @setValue="setValue"
                            />
                            <!-- WIDGETS -->

                            <Widgets 
                                :key="'widget_target_'+question.config.id"
                                :program_reference="program.reference" 
                                :survey_reference="survey.reference"
                                :question="question"
                                :questionMap="questionMap"
                                :survey="{answers:answers}"
                                :widgetRules="survey.widgets"
                                @widgetRequest="widgetRequest"
                                @log="logWidget"
                                :debug="show_dev_info"
                            />
                        <!-- </transition> -->

                        <template v-if="show_dev_info && question.display===true">
                            <v-btn @click="question.controller.clear();">Clear</v-btn> | <v-btn @click="question.controller.test.random();">Random</v-btn> | <v-btn @click="question.controller.test.validate();">Validate</v-btn>
                        </template>
                    </div>

                </template>

                <v-pagination
                v-if="enable_pagination"
                v-model="page"
                :length="pages"/>              

                <v-btn id="survey_submit_btn" v-if="enableSubmit===true" dark :class="$style.Button" @click="survey.service.send('validate_survey');" color="#00A4C0">
                    <str :index="'button > submit'"/>
                </v-btn>

                <!-- PROMPTS -->
                <template v-for="(prompt, prompt_index) in survey.prompts">
                    <SurveyPrompt :key="'prompt_'+prompt_index"
                        v-if="suppress_prompts===false"
                        :prompt="prompt" 
                        :questionMap="questionMap" 
                        :mode="survey.mode"
                        :answers="answers"
                        :promptsLog="prompts"

                        @close="close_prompt(prompt.name)"
                        @dismiss="dismiss_prompt(prompt.name)"
                        @exit="exit"
                        @restart="restart"
                        @log="logPrompt"
                        @prompt_displayed="prompt_is_displayed=$event"
                    />
                </template>
            </div>

            <Editor v-else-if="survey.state=='editing' || survey.state=='editing_cache'" 
                :survey_id="load.survey_id"
                :survey_state="survey.state"
                :edit_base_version_id.sync="edit_base_version_id"                
                @close="survey.service.send('load');"                 
                @preview="survey.service.send('preview')"
            />
            
            <h1 v-else align='center'><v-progress-circular indeterminate size="64"></v-progress-circular></h1>
            
            <VersionIndicator v-if="$store.getters.mode=='edit'"
                :edit_base_version_id="edit_base_version_id"
                :published_version_id="published_version_id"
                />
        </div>

        <v-card-actions v-if="survey.footer && survey.footer[$language()]">
            <div v-html="survey.footer[$language()]"/>
        </v-card-actions>
    </v-card>
    <v-dialog width="320" v-model="errors.submission">
        <v-card>
            <v-card-title>
                <str :index="'survey > error > submission > title'"/>
            </v-card-title>

            <v-card-text>
                <str :index="'survey > error > submission > message'"/>
            </v-card-text>

            <v-card-actions>
                <v-spacer/>
                    <v-btn @click="totalReset">
                    <str :index="'button > close'"/>
                    </v-btn>
                <v-spacer/>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import CryptoJS from 'crypto-js';
import { Machine, interpret, assign, sendParent, spawn, raise, actions, send, respond} from 'xstate';
import LogicDebugger from './LogicDebugger.vue';
import SurveyPrompt from './SurveyPrompt.vue';
import Editor from './Editor.vue';
import Select from './questionTypes/Select.vue';
import SelectTable from './questionTypes/SelectTable.vue';
import Radio from './questionTypes/Radio.vue';
import RadioTable from './questionTypes/RadioTable.vue';
import CheckboxConstrained from './questionTypes/Checkbox.vue'
import Checkbox from './questionTypes/Checkbox.vue';
import DatePicker from './questionTypes/DatePicker.vue';
import Number from './questionTypes/Number.vue';
import Percentage from './questionTypes/Percentage.vue';
import Ranking from './questionTypes/Ranking.vue';
import TextArea from './questionTypes/TextArea.vue';
import Rating from './questionTypes/Rating.vue';
import Widgets from './Widgets/Widgets.vue';
import VersionIndicator from "./assets/VersionIndicator.vue";
import OperatorConfig from '@/components/Survey/helpers/OperatorConfig.js';

export default {
    name: "survey",
    components: {
        Editor,
        LogicDebugger,
        SurveyPrompt,
        Select,
        SelectTable,
        Radio,
        RadioTable,
        Checkbox,
        CheckboxConstrained,        
        DatePicker,
        Number,
        Percentage,
        Ranking,
        TextArea,
        Rating,
        Widgets,
        VersionIndicator        
    },
    props: {
        item: {
            type: Object,
            required: true
        },
        program: {
            type: Object,
            required: true
        },
        showAllQuestionsToggleInItems: {
            type: Boolean,
            required: true
        },
        enablePaginationToggleInItems: {
            type: Boolean, 
            required: true
        },
        adminModeSelectionInItems: {
            type: String, 
            required: true
        },
        submission_record: {
            type: Object,
            required: false
        }
    },
    created: function(){

        var component = this;

        const unsubmitted = function(component){
            var self = this;

            this.cache = new function(){
                var cache = this;
                var save_timer = null;

                this.save = function(){
                    clearTimeout(save_timer);
                    save_timer = setTimeout(function(){
                        var user_id = component.$store.getters.user.id;
                        var survey_id = component.load.survey_id;
                        var storage = window.localStorage;
                        var cache = storage.getItem('survey_unsubmitted');
                        if(cache){
                            cache = JSON.parse(cache);
                        }else{
                            cache = {};
                        }
                        cache[user_id] = cache[user_id] ? cache[user_id] : {};
                        cache[user_id][survey_id] = {
                            answers: component.answers,
                            others: component.others,
                            logs: component.logs,
                            prompts: component.prompts,
                            widgets: component.widgets
                        }
    
                        var key = user_id+'_'+survey_id
                        var encrypted = CryptoJS.AES.encrypt(JSON.stringify(cache[user_id][survey_id]),key).toString();
                        cache[user_id][survey_id] = encrypted;
    
                        storage.setItem('survey_unsubmitted',JSON.stringify(cache));
                    },2000);
                }

                this.load = function(){
                    var user_id = component.$store.getters.user.id;
                    var survey_id = component.load.survey_id;
                    var storage = window.localStorage;
                    var unsubmitted = storage.getItem('survey_unsubmitted');
                    if(unsubmitted){
                        unsubmitted = JSON.parse(unsubmitted);
                        if(unsubmitted[user_id] && unsubmitted[user_id][survey_id]){
                            var key = user_id+'_'+survey_id
                            var decrypted = CryptoJS.AES.decrypt(unsubmitted[user_id][survey_id],key).toString(CryptoJS.enc.Utf8);
                            unsubmitted[user_id][survey_id] = JSON.parse(decrypted);
                            component.submissions = [unsubmitted[user_id][survey_id]];
                            component.select_answers = 0;
                            component.applyAnswers();
                        }
                    }

                    
                }

                this.available = function(){
                    var user_id = component.$store.getters.user.id;
                    var survey_id = component.load.survey_id;
                    var storage = window.localStorage;
                    var unsubmitted = storage.getItem('survey_unsubmitted');
                    if(unsubmitted){
                        unsubmitted = JSON.parse(unsubmitted);
                        if(unsubmitted[user_id] && unsubmitted[user_id][survey_id]){
                            return true   
                        }
                    }
                    return false;
                }
            }
        }

        const getCache = function(component){
            return new Promise((resolve, reject)=>{                 
                var storage = window.localStorage;
                var cached_survey = storage.getItem('survey_editor_cache');
                if(cached_survey){
                    cached_survey = JSON.parse(cached_survey);
                    component.load.survey_data = cached_survey[component.load.survey_id];
                    survey.version_id = null;
                    survey.stage = 'dev';
                    applyQuestions(component, cached_survey[component.load.survey_id]).then(function(){
                        resolve();
                    },function(response){
                        console.error('getCache error',response)
                        reject('getCache failed',response);
                    })
                }else{
                    reject('no cache found');
                }                
            })
        }

        const downloadQuestions = function(component,data){        

            return new Promise((resolve,reject)=>{
                var action='survey';
                var call='getQuestions';

                component.$sendRequest({
                    action: action,
                    call: call,
                    data: data
                }).then(function(response){
                    var reply = response.data[action][call];

                    if(reply.results.length>0){
                        var record = component.$root.parseJSON(reply.results[0]);
                        var survey_data = record.data;
                        var hasLogic = reply.hasLogic;

                        component.load.survey_data = survey_data;
                        survey.reference = record.reference;
                        survey.version_id = record.survey_version_id;
                        survey.stage = record.stage;
                        survey.header = record.header;
                        survey.footer = record.footer;

                        // survey.questions = component.load.survey_data.questions;
                        // survey.rules.display = survey_data.rules.display;
                        // survey.rules.prompts = survey_data.rules.prompts;
                        applyQuestions(component,survey_data,hasLogic).then(function(){
                            resolve(reply);
                        },function(){
                            reject();
                        });
                    }else{
                        reject(response);
                    }
                });
            });
            
        }

        const applyQuestions = function(component,survey_data,hasLogic='unknown'){
            return new Promise((resolve, reject)=>{
                survey.mode='live';
                component.initQuestion_done = false;
                component.advanced = {};
                component.started = new Date();
                component.select_answers = null;
                survey.questions = survey_data ? survey_data.questions : [];
                survey.rules.display = survey_data ? survey_data.rules.display : [];

                if(hasLogic=='unknown'){
                    downloadLogic(component,{
                        project_reference: component.program.reference,
                        survey_reference: component.survey.reference
                    }).then(function(response){

                        var promises = [];
                        promises.push(applyPrompts(component, survey_data));
                        promises.push(applyWidgets(component, survey_data));
                        Promise.all(promises).then(function(response){
                            component.survey.logic = new logic(component); //new logic will validate rules
                            resolve();
                        },function(response){
                            console.error('apply widgets/prompts',{
                                result: false,
                                response: response
                            })
                            reject('failed with prompts or widgets',response)
                        })
    
                    })
                }else{
                    if(hasLogic){                   
                        //require seems to need direct string
                        var logics = require("./programs/"+component.program.reference+"/"+component.survey.reference+".js").default;
                        for(let l in logics){
                            component.advanced[l] = logics[l];
                        }                        
                    }

                    var promises = [];
                    promises.push(applyPrompts(component, survey_data));
                    promises.push(applyWidgets(component, survey_data));
                    Promise.all(promises).then(function(response){
                        component.survey.logic = new logic(component); //new logic will validate rules
                        resolve();
                    },function(response){
                        console.error('apply widgets/prompts',{
                            result: false,
                            response: response
                        })
                        reject('failed with prompts or widgets',response)
                    });

                }          
            },function(response){
                reject('applyQuestions failed',response)
            })
        }

        const applyPrompts = function(component,survey_data){
            return new Promise((resolve, reject)=>{
                survey.prompts = (survey_data && survey_data.prompts) ? survey_data.prompts : [];
                component.prompts = {};
                var prompts = survey.prompts;
                for(let p=0; p<prompts.length; p++){
                    var prompt = prompts[p];
                    component.prompts[prompt.name] = {
                        triggered: [],
                        closed: 0,
                        dismissed: 0,
                        restarted: 0
                    }
                }
                resolve();
            },function(){
                reject('Failed to apply prompts');
            })
        }

        const applyWidgets = function(component,survey_data){
            return new Promise((resolve, reject)=>{
                survey.widgets = (survey_data && survey_data.widgets) ? survey_data.widgets : [];
                component.widgets = {};
                var widgets = survey.widgets;
                for(let p=0; p<widgets.length; p++){
                    var widget = widgets[p];
                    component.widgets[widget.name] = {
                        display_target: widget.display_target,
                        triggered: [],
                        close: 0,
                        dismiss: 0,
                        reconsider: 0,
                        continue: 0
                    }
                }
                resolve();
            },function(){
                reject('Failed to apply widgets');
            })
        }

        const downloadLogic = function(component,data){        

            return new Promise((resolve,reject)=>{
                var action='survey';
                var call='downloadLogic';
                component.$sendRequest({
                    action: action,
                    call: call,
                    data: data
                }).then(function(response){
                    var reply = response.data[action][call];
                    if(reply.file_exists){
                        var logics = require("./programs/"+component.program.reference+"/"+component.survey.reference+".js").default;
                        for(let l in logics){
                            component.advanced[l] = logics[l];
                        }
                        
                    }
                    resolve(reply);
                },function(response){
                    reject(response);
                });
            });
            
        }
        
        const logic = function(component){
            var self = this;

            this.init = function(){
                
                if(component.survey.prompts){

                    for(let i=0; i<component.survey.prompts.length; i++){
                        var prompt = component.survey.prompts[i];
                        var onTrigger = null;
                        if(typeof prompt.onTrigger=='string'){
                            eval("onTrigger=function(questionMap, language, component){"+prompt.onTrigger+"}");
                            prompt.onTrigger = onTrigger;
                        }

                        for(let r=0; r<prompt.rules.length; r++){
                            var rule = prompt.rules[r];

                            for(let c=0; c<rule.conditions.length; c++){
                                var condition = rule.conditions[c];
                                var funk = null;
                                if(typeof condition.advanced == 'string'){
                                    eval("funk=function(question, questionMap, language, component){"+condition.advanced+"}");
                                    condition.advanced = funk;
                                }
                            }
                        }
                    }

                }
                
                if(component.survey.widgets){

                    for(let i=0; i<component.survey.widgets.length; i++){
                        var widget = component.survey.widgets[i];
                        var onTrigger = null;
                        if(typeof widget.onTrigger=='string'){
                            eval("onTrigger=function(questionMap, language, survey, component){"+widget.onTrigger+"}");
                            widget.onTrigger = onTrigger;
                        }
                        widget.display_target = typeof widget.display_target=='string' ? JSON.parse(widget.display_target) : [];

                        for(let r=0; r<widget.rules.length; r++){
                            var rule = widget.rules[r];

                            for(let c=0; c<rule.conditions.length; c++){
                                var condition = rule.conditions[c];
                                var funk = null;
                                if(typeof condition.advanced == 'string'){
                                    eval("funk=function(question, questionMap, language, survey, component){"+condition.advanced+"}");
                                    condition.advanced = funk;
                                }

                                var funk = null;
                                if(typeof condition.watcher == 'string'){
                                    eval("funk=function(question, questionMap, language, survey, component){"+condition.watcher+"}");
                                    condition.watcher = funk;
                                }
                            }
                        }
                    }

                }

                if(component.survey.rules.display){
                    for(let question_id in component.survey.rules.display){
                        var rule = component.survey.rules.display[question_id];
                        

                        for(let r=0; r<rule.length; r++){
                            var conditions = rule[r];
                            
                            for(let c=0; c<conditions.length; c++){
                                var condition = conditions[c];
                                
                                var funk = null;
                                if(typeof condition.advanced == 'string'){
                                    eval("funk=function(question, questionMap, language){"+condition.advanced+"}");
                                    condition.advanced = funk;
                                }
                            }
                        }
                    }
                }
            }

            this.display = function(){
                var questionRules = component.survey.rules.display;            
                var output = {};

                //Go through each rule (this is will be index by question ID)
                for(let question_id in questionRules){
                    var results = [];

                    var anyOfThese = questionRules[question_id];

                    for(let index_any=0; index_any<anyOfThese.length; index_any++){
                        var allofThese = anyOfThese[index_any];
                        results.push({});
                        
                        for(let i=0; i<allofThese.length; i++){
                            var rule = allofThese[i];
                            
                            var result = false;
                            var trigger = null;
                            var details = null;


                            var type = rule.type ? rule.type : 'question';
                            var group_id = rule.group_id ? rule.group_id : 1;
                            var reference = type == 'question' ? component.questionMap[rule.ref_id] : component.survey.context[rule.ref_id];

                            if(reference){
                                if(reference.value){

                                    if(rule.advanced!=null && typeof rule.advanced=='function'){
                                        result = rule.advanced(reference, component.questionMap, component.$language());

                                        if(result){
                                            details = 'advanced function';
                                            trigger = rule.name;
                                        }
                                    }

                                    if(rule.input_id!=null && reference.value[group_id]){
                                        switch(reference.config.type){
                                            default:
                                                result = reference.value[group_id] == rule.input_id;
                                            break;

                                            case"checkbox":
                                                result = component.$root.in_array(rule.input_id,reference.value[group_id]);
                                            break;
                                        }

                                        if(result){
                                            details = rule.input_id;
                                            trigger = rule.name;
                                        }
                                    }
                                    
                                    if (rule.contains!=null && reference.value){
                                        var found = OperatorConfig.check_logic_gate.contains(rule, reference, details, group_id);
                                        if(found){
                                            result = true;
                                            trigger = rule.name;                                          
                                        }
                                    }
                                    
                                    if (rule.not_contains!=null && reference.value){
                                        let not_contains = OperatorConfig.check_logic_gate.not_contains(rule, reference, details, group_id);
                                        if (not_contains){
                                            result = true;
                                            trigger = rule.name;                                           
                                        }
                                    }
        
                                    if (rule.equals!=null && OperatorConfig.check_logic_gate.equals(rule, reference, group_id)){
                                        result = true;
                                        trigger = rule.name;
                                    }
        
                                    if (rule.greater_than!=null && OperatorConfig.check_logic_gate.greater_than(rule, reference, group_id)){
                                        result = true;
                                        trigger = rule.name;
                                    }
                                    
                                    if (rule.greater_than_or_equal!=null && OperatorConfig.check_logic_gate.greater_than_or_equal(rule, reference, group_id)){
                                        result = true;
                                        trigger = rule.name;
                                    }
        
                                    if(rule.less_than!=null && OperatorConfig.check_logic_gate.less_than(rule, reference, group_id)){
                                        result = true;
                                        trigger = rule.name;
                                    }
                                    
                                    if(rule.less_than_or_equal!=null && OperatorConfig.check_logic_gate.less_than_or_equal(rule, reference, group_id)){
                                        result = true;
                                        trigger = rule.name;
                                    }
                                    
                                    if(rule.is_answered!=null){
                                        var isAnswered = false;
                                        for(let i in reference.value){
                                            var group_answer = reference.value[i];
    
                                            if(group_answer!=null){
                                                switch(typeof group_answer){
                                                    default:
                                                        if(group_answer!=null){
                                                            isAnswered = true;
                                                            break;
                                                        }
                                                    break;
        
                                                    case"object":
                                                        if(group_answer.length>0){
                                                            isAnswered = true;
                                                            break;
                                                        }
                                                    break;
                                                }
                                            }
    
                                        }
    
                                        result = isAnswered;
                                        trigger = rule.name;
                                    }
    
                                    if(rule.is_valid!=null && reference.valid===true){
                                        result = true;
                                        trigger = rule.name;
                                    }
        
                                    if(rule.is_visible!=null && reference.display===true){
                                        result = true;
                                        trigger = rule.name;
                                    }
                                }

                            }else{
                                console.error("Missing "+type+" reference for logic: "+rule.ref_id, rule)
                                break;
                            }
                            
                            
                            results[index_any][rule.name] = {
                                result: result,
                                trigger: trigger,
                                details: details
                            };
                        }
                    }

                    output[question_id] = results;
                }
                
                return output;
            }

            this.valid = function (){
                this.customCLog('valid',component.survey.rules.valid)
            }

            this.action = function(trigger){
                var actionRules = component.survey.rules.action;
                for(let question_id in actionRules){
                    var doThis = actionRules[question_id];
                    if(question_id==trigger){
                        doThis({
                            question: component.questionMap[question_id],
                            survey: component.survey,
                            questionMap: component.questionMap
                        });
                    }
                }
            }

            this.validateRules = new function(){

                this.execute = function(){
                    return new Promise((resolve, reject)=>{
                        var promises = [];
                        promises.push(this.references_exist());
                        promises.push(this.reference_types());
                        Promise.all(promises).then(function(response){
                            resolve();
                        },function(response){
                            reject();
                        })
                    });
                    
                }

                this.references_exist = function(){
                    return new Promise((resolve, reject)=>{
                        var ruleTypes = component.survey.rules;
                        var questionMap = component.questionMap;

                        var displayRules = ruleTypes.display;
                        

                        for(let question_id in displayRules){
                            var rules = displayRules[question_id];

                            for(let rule_index=0; rule_index<rules.length; rule_index++){
                                var conditions = rules[rule_index];

                                for(let condition_index=0; condition_index<conditions.length; condition_index++){
                                    var condition = conditions[condition_index];
                                    
                                    switch(condition.type){
                                        case"question":
                                            var reference = questionMap[condition.ref_id];
                                        break;
                                    }
                                }


                            }
                        }
                        resolve('reference_exists')
                    })
                }

                this.reference_types = function(){
                    return new Promise((resolve, reject)=>{
                        resolve('reference_types')
                    })
                }
                
            }

            this.init();
        }

        const submit_survey = async function(component){
            // force submission call delay when survey is small and submission button visible in viewport window and Prompt display rule in-affect
            await new Promise(resolve => setTimeout(resolve, 2000));
            if (component.prompt_is_displayed===true){
                return new Promise((resolve, reject)=>{
                    component.prompt_is_displayed===false
                    reject("PROMPT_TRIGGERED_RELATED_ISSUE")
                })
            }
            
            return new Promise((resolve, reject)=>{
                var action = 'survey';
                var call = 'submit_survey';

                if(component.load.survey_id && component.survey.version_id){
                    var data = {
                            survey_id: component.load.survey_id,
                            version_id: component.survey.version_id,
                            answers: component.answers,
                            others: component.others,
                            prompts: component.prompts,
                            widgets: component.widgets,
                            logs: component.logs,
                            context: component.context,
                            language: component.$language(),
                            role: component.program.role,
                            program_id: component.program.id,
                            started: component.started,
                            time_spent: component.fromStart(),
                            stage: component.survey.stage
                    }
                    component.$sendRequest({
                        action: action,
                        call: call,
                        data: data
                    }).then(function(response){
                        var reply = response.data[action][call];
                        if(reply.submission===true){
                            component.submission_id = reply.submission_id;
                            if(component.advanced.afterSubmit){
                                component.advanced.afterSubmit(component, reply).then(function(){
                                    resolve();
                                },function(response){
                                    reject('logic error: afterSubmit',response)
                                });
                            }else{
                                resolve();
                            }
                        }else{
                            reject('submission error: ',response)
                        }

                    },function(response){
                        reject('SUBMISSION FAILED');
                    })
                }else{
                    reject("PLEASE CHECK: [version_id, survey_id]")
                }
            })
        }

        const get_answers = function(component){
            return new Promise((resolve, reject)=>{
                var action = 'survey';
                var call = 'getSubmissions';
                var data = {
                    survey_id: component.load.survey_id,
                    program_id: component.program.id,
                    role: component.program.role,
                    version_id: component.survey.version_id
                }
                component.$sendRequest({
                    action: action,
                    call: call,
                    data: data
                }).then(function(response){
                    var reply = response.data[action][call];
                    component.submissions = reply.results;
                    for(let i=0; i<component.submissions.length; i++){

                        component.submissions[i].answers = JSON.parse(component.submissions[i].answers);
                        component.submissions[i].others = JSON.parse(component.submissions[i].others);
                        component.submissions[i].logs = JSON.parse(component.submissions[i].logs);
                        component.submissions[i].prompts = JSON.parse(component.submissions[i].prompts);
                    }
                    resolve()
                },function(response){
                    reject(response);
                })

            })
        }

        var surveyConfig = {
            id: 'survey',
            initial: 'idle',
            states: {
                idle: {
                    on: {
                        load:'downloadQuestions',
                        edit: 'editing'
                    }
                },
                loadCache: {
                    invoke: {
                        id: 'fetch-cache',
                        src: (context, event) => new Promise((resolve, reject)=>{
                            component.started = null;
                            getCache(component).then(function(){
                                resolve();
                            },function(response){
                                console.error('loadCache error',response)
                                reject();
                            })
                        }),
                        onDone: {
                            target: 'ready'
                        },
                        onError: {
                            target: 'error-load-cache'
                        }
                    }                           
                },
                "error-load-cache": {
                    on: {
                        load: 'downloadQuestions',
                        preview: 'loadCache',
                        edit: 'editing'
                    }
                },
                downloadQuestions: {
                    invoke: {
                        id: 'fetch-questions',
                        src: (context, event) => new Promise((resolve,reject)=>{
                            component.started = null;
                            downloadQuestions(component,{program_id: component.load.program_id, project_reference: component.program.reference, survey_id: component.load.survey_id}).then(function(){
                                resolve();
                            },function(){
                                reject();
                            })
                        }),
                        onDone: {
                            target: 'ready'
                        },
                        onError: {
                            target: 'error-load-questions'
                        }
                    }                    
                },
                "error-load-questions": {
                    on: {
                        load: 'downloadQuestions',
                        edit: 'editing'
                    }
                },
                // download_logic: {
                //     invoke: {
                //         src: (context, event) => downloadLogic(component,{program: this.program.subdomain, survey: component.load.survey_id}),
                //         onDone: {
                //             target: 'ready'
                //         },
                //         onError: {
                //             target: 'error-download-logic'
                //         }
                //     }                    
                // },
                "error-download-logic": {
                    on: {
                        load: 'downloadQuestions',
                        edit: 'editing'
                    }
                },
                "validate-rules": {
                    invoke: {
                        src: (context, event) => new Promise((resolve, reject)=>{
                            component.survey.logic.validateRules.execute().then(function(){
                                resolve();
                            },function(){
                                reject();
                            })
                        }),
                        onDone: {
                            target: 'ready'
                        },
                        onError: {
                            target: 'error-validate-rules'
                        }
                    }                  
                },
                "error-validate-rules": {
                    on: {
                        load: 'downloadQuestions',
                        edit: 'editing'
                    }
                },
                ready: {
                    on: {
                        load: 'downloadQuestions',
                        edit: 'editing',
                        edit_cache: 'editing_cache',
                        preview: 'loadCache',
                        submit_survey: 'submit_survey',
                        validate_survey: 'validate_survey',
                        submit_complete: 'submit_complete',
                        // download_logic: 'download_logic'
                    }
                },
                editing: {
                    on: {
                        load: 'downloadQuestions',
                        ready: 'ready',
                        preview: 'loadCache',
                        edit: 'editing',
                        edit_cache: 'editing_cache'
                    }
                },
                editing_cache: {
                    on: {
                        load: 'downloadQuestions',
                        ready: 'ready',
                        preview: 'loadCache',
                        edit: 'editing',
                        edit_cache: 'editing_cache'
                    }
                },
                validate_survey: {
                    invoke: {
                        src: (context, event) => new Promise((resolve, reject)=>{
                            component.validate_survey().then(function(response){
                                resolve();
                            },function(response){
                                reject(response);
                            })
                        }),
                        onDone: {
                            target: 'submit_survey'
                        },
                        onError:{
                            target: 'ready'
                        }
                    },
                    on: {
                        validate_survey: 'validate_survey',
                        ready: 'ready'
                    }
                },
                submit_survey: {
                    invoke: {
                        src: (context, event) => new Promise((resolve, reject)=>{
                            submit_survey(component).then(function(){
                                resolve();
                                var storage = window.localStorage;
                                var unsubmitted = storage.getItem('survey_unsubmitted');
                                unsubmitted = JSON.parse(unsubmitted);
                                var user_id = component.$store.getters.user.id;
                                var survey_id = component.load.survey_id;
                                delete unsubmitted[user_id][survey_id];
                                storage.setItem('survey_unsubmitted',JSON.stringify(unsubmitted));
                            },function(issue){
                                console.error('submit_survey error',issue);
                                if (issue!=='PROMPT_TRIGGERED_RELATED_ISSUE'){
                                    component.errors.submission=true
                                }
                                reject();
                            })
                        }),
                        onDone: {
                            target: 'submit_complete'
                        },
                        onError: {
                            target: 'ready'
                        }
                    }
                },
                submit_complete: {
                    invoke: {
                        src: (context, event) => new Promise((resolve, reject)=>{
                            component.$emit('survey_submission',{
                                submission: {
                                        survey_id: component.load.survey_id,
                                        version_id: component.survey.version_id,
                                        answers: component.answers,
                                        others: component.others,
                                        prompts: component.prompts,
                                        widgets: component.widgets,
                                        logs: component.logs,
                                        context: component.context,
                                        language: component.$language(),
                                        role: component.program.role,
                                        program_id: component.program.id,
                                        started: component.started,
                                        time_spent: component.fromStart(),
                                        stage: component.survey.stage,
                                        submission_id: component.submission_id
                                }
                            });
                            if(component.survey.mode=='live'){
                                component.init();
                            }else{
                                get_answers(component).then(function(){})
                            }

                        })
                    },
                    on: {
                        load: 'downloadQuestions',
                        edit: 'editing',
                        edit_cache: 'editing_cache',
                        preview: 'loadCache',
                        submit_complete: 'submit_complete',
                        ready: 'ready'
                    }
                }
            }
        }

        const surveyMachine = Machine(surveyConfig);
        var survey = {
            version_id: null,
            machine: surveyMachine,
            service: interpret(surveyMachine),
            state: surveyMachine.initialState,
            context: surveyMachine.context,
            questions: [],
            rules: {},
            logic: {},
            prompts: [],
            initQuestion_done: false,
            valid_survey: false,
            mode: component.adminModeSelectionInItems,
            stage: 'dev',
            header: null,
            footer: null
        }

        survey.service.onTransition(state => {
            survey.state = state.value;
            survey.context = state.context
        }).start();

        this.survey = survey;
        this.unsubmitted = new unsubmitted(component);

    },
    mounted: function(){
        this.init('mounted');
    },
    data: function(){
        return {
            errors: {
                submission: false
            },
            published_version_id: null,
            survey: null,
            enableSubmit: true,
            started: null,
            initQuestion_timer: null,
            initQuestion_done: false,
            load: {
                program_id: null,
                survey_id: null,
                survey_data: null
            },
            suppress_prompts: false,
            prompts: {},
            widgets: {},
            logs: [],
            context: {},
            submissions: [],
            incompleteCounter: 0,
            select_answers: null,
            show_raw_answers: false,
            show_question_jumper: false,
            advanced: {},
            showDevTools: false,
            unsubmitted: null,
            display_incomplete_dialog: true,
            page: 1,
            questions_per_page: 10,
            edit_base_version_id: null,
            submission_id: null,
            prompt_is_displayed: false,
        }
    },
    methods: {
        init: function(caller){
            this.loadSurvey(this.program.id, this.item.item_id);           
            window.survey = this.survey;
        },
        close_prompt: function(prompt_name){
            this.logPrompt({
                event: 'closed',
                prompt_name: prompt_name
            })
        },
        dismiss_prompt: function(prompt_name){
            this.logPrompt({
                event: 'dismissed',
                prompt_name: prompt_name
            })
        },
        exit: function(){
            this.$router.push({ path: '/' })
        },
        restart: function(){
            this.survey.service.send('load');
        },
        loadSurvey: function(program_id, survey_id){
            this.load.program_id = program_id ? program_id : this.program.id;
            this.load.survey_id = survey_id ? survey_id : this.item.item_id;
            this.survey.service.send('load');
        },
        editSavedSurvey: function() {
            this.survey.service.send('edit');
        },
        editCachedSurvey: function() {
            this.survey.service.send('edit_cache');
        },
        previewCachedSurvey: function() {
            this.survey.mode='live';
            this.survey.service.send('preview');
        },
        makeSurveyReady: function() {
            if(this.survey.state == 'validate_survey') {
                this.survey.service.send('ready');
            }
        },
        fromStart: function(){
            var newTime = new Date();
            return (newTime - this.started) / 1000;
        },
        initQuestion: function(data){
            var self = this;
            self.initQuestion_done = false;
            self.survey.initQuestion_done = false;
            clearTimeout(self.initQuestion_timer);
            var question = this.questionMap[data.question.config.id];
            question.$root = this.$root;
            question.controller = data.controller;
            question.config = data.question.config;
            question.configMap = data.configMap;
            question.valid = data.valid;
            question.update = new function(){
                this.header = function(object){
                    if(typeof object=='object'){
                        question.config.header = object;
                    }else{
                        console.error('Expect object with language codes')
                    }
                }
                this.subtext = function(object){
                    if(typeof object=='object'){
                        question.config.subtext = object;
                    }else{
                        console.error('Expect object with language codes')
                    }
                }
                this.body = function(object){
                    if(typeof object=='object'){
                        question.config.body = object;
                    }else{
                        console.error('Expect object with language codes')
                    }
                }
                this.footer = function(object){
                    if(typeof object=='object'){
                        question.config.footer = object;
                    }else{
                        console.error('Expect object with language codes')
                    }
                }
            }
            if(question.actions!=null){
                var funk = null;
                eval("funk = function(question, questionMap, language){"+question.actions+"}");
                question.actions = funk;
            }
            question.focus = function(){
                var id = "sid_"+self.load.survey_id+"_qid_"+question.config.id;
                var element = document.getElementById(id);
                var position = self.$root.offset(element);
                element.scrollIntoView()
                window.scroll({ top: position.top, left: 0, behavior: 'smooth' });
            }

            self.initQuestion_timer = setTimeout(function(){
                self.initQuestion_done = true;
                self.survey.initQuestion_done = true;
                self.showhide();//set intial display conditions 
                if(self.advanced.afterInit){
                    self.advanced.afterInit(self);
                }               
            },1000)
        },
        setValue: function(data){
            var self = this;
            var question = data.question;
            question.value = data.value;
            question.other = data.other;
            question.valid = data.valid;

            if(self.initQuestion_done===true){
                var trigger = question.config.id;
                
                self.logs.push({
                    question: question.config.id,
                    value: question.value,
                    other: question.other,
                    from_start: self.fromStart()
                })
                self.showhide(trigger, data.value);
                if( typeof question.actions=='function' ){
                    question.actions(question, self.questionMap, self.$language());
                }

                self.unsubmitted.cache.save();
            }
        },
        showhide: function(trigger, value){
            var survey = this.survey;

            var output = survey.logic.display()
            for(let id in output){
                var anyOfThese = output[id];
                var question = this.questionMap[id];

                if(question){
                    var anyPasses = false;
                    
                    for(let i=0; i<anyOfThese.length; i++){
                        var allOfThese = anyOfThese[i];
                        var allPasses = true;
    
                        for(let rule_name in allOfThese){
                            var rule = allOfThese[rule_name];
                            if(!rule.result){
                                allPasses = false;
                            }
                        }
    
                        if(allPasses){
                            anyPasses = true;
                        }
                    }
    
                    question.display = anyPasses;
                    question.display_triggers = output[id];
                }else{
                    console.error('SHOW/HIDE - Missing target question', id)
                }
            }

        },
        takeAction: function(trigger){
            var self = this;
            self.survey.logic.action(trigger);
        },
        randomAnswers: function(){
            var self = this;
            var max = this.survey.questions.length;
            var counter = 0;
            var delay = 0;

            random();

            function random(){
                if(counter<max){
                    
                    delay=800;
                    setTimeout(function(){
                        randomAnswer();
                        random();
                    },delay);

                    
                }
            }

            function randomAnswer(){
                var question = self.survey.questions[counter];
                counter++; 
                if(question.display===true){
                    question.controller.test.random();
                }else{                                   
                    randomAnswer();
                }
            }
        },
        getAnswers: function() {
            this.survey.mode='dev';
            this.survey.service.send('submit_complete');
        },
        widgetRequest: function(data){
            if(typeof data.request == 'function'){
                data.request(this);
            }
        },
        validate_survey: function(){
            return new Promise((resolve, reject)=>{
                var valid = true;
                for(let i=0; i<this.survey.questions.length; i++){
                    var question = this.survey.questions[i];
                    if(question.display===true && !(question.valid.default && question.valid.advanced)){
                        question.focus();
                        valid = false;
                        break;
                    }
                }
                this.survey.valid_survey = valid;
                if(valid){
                    resolve(valid);
                }
            },function(){
                reject('error validating survey')
            });
        },
        logPrompt: function(data){
            var prompt_name = data.prompt_name;
            switch(data.event){
                default:
                    this.prompts[prompt_name][data.event]++;
                break;

                case"triggered":
                    var record = {}
                    record[data.rule] = data.conditions;
                    this.prompts[prompt_name].triggered.push(record);
                break;
            }
        },
        logWidget: function(data){
            var widget_name = data.widget_name;
            switch(data.event){
                default:
                    this.widgets[widget_name][data.event]++;
                break;

                case"triggered":
                    var record = {}
                    record[data.rule] = data.conditions;
                    this.widgets[widget_name].triggered.push(record);
                break;
            }
        },
        emit_submit: function(){
            var data = {
                item: this.item,
                step: this.$route.params.step
            }
            this.$emit('survey_submission',data)
        },
        get_answers: function(){
            get_answers(this)
        },
        afterSubmit: function(){
            this.survey.mode='dev';
            this.advanced.afterSubmit(this);
        },
        applyAnswers: function(submission_record){
            var self = this;
            var index = this.select_answers;
            var submission = submission_record ? submission_record : this.submissions[index];

            var record = {
                answers: submission.answers, //JSON.parse(submission.answers),
                others: submission.others, //JSON.parse(submission.others),
                logs: submission.logs, //JSON.parse(submission.logs)
                prompts: submission.prompts,
                widgets: submission.widgets
            }
            for(let qid in record.answers){
                var answer = record.answers[qid];
                var question = return_question(qid);
                for(let group_id in answer){
                    var value = answer[group_id];
                    if(value){
                        question.controller.setValue(group_id,value);
                    }
                }
            }

            for(let qid in record.others){
                var others = record.others[qid];
                var question = return_question(qid);
                
                for(let group_id in others){
                    var inputs = others[group_id];
                    for(let i in inputs){
                        var input = inputs[i];
                        if(input){
                            question.other[group_id][i] = input;
                        }
                    }
                }
            }

            this.logs = record.logs;
            this.prompts = record.prompts;
            this.widgets = record.widgets;
            this.survey.service.send('ready');

            function return_question(qid){
                for(let i=0; i<self.survey.questions.length; i++){
                    var question = self.survey.questions[i];
                    if(question.config.id == qid){
                        return question;
                    }
                }
            }
        },
        question_segment: function(question_index){
            var questions_per_page = this.questions_per_page;
            var display_stop = questions_per_page * this.page;
            var display_start = questions_per_page * this.page - questions_per_page;
            return this.enable_pagination===true ? question_index >= display_start && question_index<=display_stop : true;
        },
        checkShownQuestionIdEvenIndex: function(target_question, question_index, all_questions) {
            let questionIndex = this.filterDisplaySurveyQuestions.findIndex(question => question.config.id === target_question.config.id);
            if(questionIndex > 0 && (questionIndex + 1) % 2 === 0) {
                return true;
            }
            return false;
        },
        totalReset: function(){
            this.errors.submission=false
            window.location.reload()
        }
    },
    computed: {
        surveyReady: function(){
            return this.survey && this.survey.state == 'ready';
        },
        validateRules: function(){
            return this.survey && this.survey.state == 'validate-rules';
        },
        questionMap: function(){
            var output = {};
            for(let i=0; i<this.survey.questions.length; i++){
                var question = this.survey.questions[i];
                output[question.config.id] = question
            }

            return output;
        },
        answers: function(){
            var answers = {};
            for(let i=0; i<this.survey.questions.length; i++){
                var question = this.survey.questions[i];
                answers[question.config.id] = question.value;
            }
            return answers;
        },
        others: function(){
            var others = {};
            for(let i=0; i<this.survey.questions.length; i++){
                var question = this.survey.questions[i];
                others[question.config.id] = question.other;
            }
            return others;
        },
        submissions_list: function(){
            var list = [];
            var total = this.submissions.length;
            for(let i=0; i<this.submissions.length; i++){
                var submission = this.submissions[i];
                var warning = submission.version_id!=this.survey.version_id ? '*** DIFFERENT VERSION ***' : '';
                list.push({
                    text: '#'+(total-i)+' '+warning+' [Version: '+submission.version_id+'] '+submission.timestamp,
                    value: i
                });
            }

            return list;
        },
        incomplete_questions: function(){
            var list = [];            
            let survey_questions = this.survey ? this.survey.questions : null;
            if(survey_questions) {
                for(let i=0; i<survey_questions.length; i++){
                    var question = {...survey_questions[i]};
                    if(question.display && question.valid){
                        if(!(question.valid.default && question.valid.advanced)){
                            list.push(question);
                        }
                    }
                }
            }
            return list;
        },
        overlay_submission: function(){
            var answers = null;
            var others = null;
            var logs = null;
            var select_answers = this.select_answers;
            if(select_answers!=null){
                answers = (this.submissions[select_answers].answers);
                others = (this.submissions[select_answers].others);
                logs = (this.submissions[select_answers].logs);
                return {
                    answers: answers,
                    others: others,
                    logs: logs
                }
            }else{
                return null
            }

        },
        show_dev_info: function(){
            return this.survey.mode=='dev_run_hidden_logics' || this.survey.mode=='dev' || this.survey.mode=='test';
        },
        survey_state: function(){
            return this.survey ? this.survey.state : null;
        },
        pages: function(){
            return this.survey && this.survey.questions ? Math.round(this.survey.questions.length / this.questions_per_page) : 0
        },
        showAll: {
            get: function() {
                return this.showAllQuestionsToggleInItems;
            },
            set: function(newValue) {
                this.$emit('update:showAllQuestionsToggleInItems', newValue);
            }
        },
        enable_pagination: {
            get: function() {
                return this.enablePaginationToggleInItems;
            },
            set: function(newValue) {
                this.$emit('update:enablePaginationToggleInItems', newValue);
            }
        },
        filterDisplaySurveyQuestions: function() {
            if(this.survey && this.survey.questions) {
                let filterDisplaySurveyQuestions = this.survey.questions.filter(question => question.display === true);
                return filterDisplaySurveyQuestions;
            } else {
                return []
            }
        }
    },
    watch: {
        survey_state: function(){
            if(this.survey_state=='validate_survey'){
                this.display_incomplete_dialog = this.incomplete_questions.length>0;
            }
        },
        surveyReady: function(after, before){
            if (after && this.survey.version_id!==null) {
                this.published_version_id = this.survey.version_id;
            }
        },
        adminModeSelectionInItems: function(after) {
            this.survey.mode = after;
        },
        'survey.mode': function(after) {
            this.$emit('update:adminModeSelectionInItems', after);
        },
        survey_state: function(){
            if(this.survey_state=='ready' && this.submission_record){
                let self = this;
                setTimeout(function(){
                    self.applyAnswers(self.submission_record);
                },2000)
            }
        },
        incomplete_questions: function(after, before) {
            if(after.length < before.length && after.length === 0) {
                // location.href = "#survey_submit_btn";
                document.getElementById("survey_submit_btn").scrollIntoView({behavior: "smooth"});
            }
        }
    }
}
</script>

<style>
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-20px);
  opacity: 0;
}

#Box .v-input--selection-controls {
    margin-top: 10px;
    padding-top: 0px;
}
#Box .v-card {
    box-shadow: none !important;
}

#Box .v-text-field--outlined>.v-input__control>.v-input__slot {
    min-height:40px !important;
}

#Box .theme--light.v-sheet {
    background-color: inherit !important;
}

#Box .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
    margin-bottom: 20px;
}
</style>

<style module>
.shownQuestion{
    margin: 10px 0px;
}

.shownQuestionAltBackgroundShowAll:nth-child(even) {
    background-color:#fafafa;
}

.shownQuestionAltBackground {
    background-color:#fafafa !important;
}

.Button {
    position: inherit;
    margin-left: 45%;
    text-align: center;
}

.incomplete{
    border: 1px solid red;
    width: 100%;
}

.devTools{
    position: fixed; 
    left: 50%;
    transform: translateX(-50%);
    bottom: 20px; 
    width: 60%;
    z-index:1000;
    text-align: center;
    background-color: whitesmoke;
}

.devTools button{
    margin: 5px;
}

.devToolsWrenchBtnWrapper {
    position: fixed;
    right: -30.5%;
    bottom: 100px;
}

.completionAssistant {
    z-index: 3; 
    position:fixed; 
    top: 65px; 
    left:0px; 
    padding: 8px; 
    min-height: 100px; 
    margin: 0 auto; 
    text-align: center;
    width: 100%;
    background: rgb(255,255,255);
    background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(243,243,243,1) 100%);
    box-shadow: 3px 3px 3px #ccc;    
    border-top: 1px solid #eaeaea;
}
</style>
